import React, { createContext, useContext, useState, useEffect } from 'react';
import Loading from '@/components/Loading';
import { SiteConfig } from '@/types/config';

export const SiteConfigContext = createContext<SiteConfig | null>(null);

export const SiteConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [config, setConfig] = useState<SiteConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 如果没有缓存，则从服务器获取
    fetch('/site.json')
      .then((res) => res.json())
      .then((data) => {
        setConfig(data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;
  if (!config) return null;

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
};
// 创建 hook 用于获取配置
export const useSiteConfig = () => {
  const context = useContext(SiteConfigContext);
  if (!context) {
    throw new Error('useSiteConfig must be used within a SiteConfigProvider');
  }
  return context;
};
